import React from "react";
import "./css/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy">
      <h1>Privacy Policy for Lifoura</h1>
      <p><strong>Effective Date:</strong> June 27, 2025</p>

      <p>
        At <strong>Lifoura</strong> ("we", "our", "us"), your privacy is a top priority. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services.
      </p>

      <hr />

      <h2>1. Information We Collect</h2>
      <h3>a) Personal Information</h3>
      <ul>
        <li>Name, email address, and contact details</li>
        <li>Encrypted login credentials</li>
      </ul>

      <h3>b) Media Content</h3>
      <ul>
        <li>Photos and videos you upload</li>
        <li>Metadata like upload time, file type</li>
      </ul>

      <h3>c) Usage Data</h3>
      <ul>
        <li>IP address, browser type, device details</li>
        <li>Activity logs (pages visited, actions performed)</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To provide and enhance the media storage service</li>
        <li>To personalize your experience</li>
        <li>To communicate updates and support messages</li>
        <li>To detect or prevent fraud and technical issues</li>
      </ul>

      <h2>3. Media Storage and Access</h2>
      <ul>
        <li>Your files are stored securely and privately.</li>
        <li>We do <strong>not</strong> sell or view your content.</li>
        <li>Only you or users you share access with can view your files.</li>
      </ul>

      <h2>4. Sharing of Information</h2>
      <p>We do <strong>not</strong> sell or rent your personal or media data. We may share data only:</p>
      <ul>
        <li>With service providers under strict confidentiality</li>
        <li>To comply with legal obligations</li>
        <li>To prevent fraud or abuse of the service</li>
      </ul>

      <h2>5. Cookies and Tracking</h2>
      <p>We use cookies to:</p>
      <ul>
        <li>Keep you logged in</li>
        <li>Save your preferences</li>
        <li>Track usage to improve the platform</li>
      </ul>
      <p>You may disable cookies, but some features may stop working.</p>

      <h2>6. Your Rights and Choices</h2>
      <ul>
        <li>Access and update your profile</li>
        <li>Delete your account and media</li>
        <li>Request a copy of your data</li>
        <li>Withdraw consent anytime</li>
      </ul>
      <p>Email <strong>support@lifoura.com</strong> for assistance.</p>

      <h2>7. Data Security</h2>
      <p>We protect your data using:</p>
      <ul>
        <li>SSL encryption</li>
        <li>Firewall and access control</li>
        <li>Regular backups</li>
      </ul>
      <p>No system is completely secure — use Lifoura wisely.</p>

      <h2>8. Children's Privacy</h2>
      <p>We do not knowingly collect data from children under 13 without parental permission. Contact us if you suspect we have done so.</p>

      <h2>9. Changes to This Policy</h2>
      <p>We may update this Privacy Policy. We'll notify users of any major changes via email or platform alerts.</p>
      <p><strong>Last updated:</strong> June 27, 2025</p>

      <h2>10. Contact Us</h2>
      <p>Have questions or feedback?</p>
      <p>
        <strong>Email:</strong> <a href="mailto:support@lifoura.com">support@lifoura.com</a><br />
        <strong>Website:</strong> <a href="https://www.lifoura.com" target="_blank" rel="noopener noreferrer">www.lifoura.com</a>
      </p>
    </section>
  );
};

export default PrivacyPolicy;
